/* eslint-disable */

import { Button, DatePicker, Form, Input, Select, Upload } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";

export default function BannerForm({ data, onSubmit, onFinish }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const isEdit = !!data;

  useEffect(() => {
    form.resetFields();
  }, [form, data]);

  const handleSubmitForm = async (values) => {
    setLoading(true);

    const { description, screen, to } = values;
    const start_date = values.start_date.toDate().toString();
    const end_date = values.end_date
      ? values.end_date.toDate().toString()
      : undefined;
    const payload = screen ? { screen, to } : undefined;

    const formData = new FormData();
    if(values.file?.file) formData.append("file", values.file.file);
    formData.append(
      "data",
      JSON.stringify({ description, payload, start_date, end_date })
    );

    try {
      await onSubmit(formData);
      onFinish();
    } catch (e) {
      debugger
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      initialValues={{
        description: data?.description,
        start_date: data?.start_date ? moment(data.start_date) : undefined,
        end_date: data?.end_date ? moment(data.end_date) : undefined,
        screen: data?.payload?.screen,
        to: data?.payload?.to,
      }}
      onFinish={handleSubmitForm}
    >
      <h3>{isEdit ? 'Edit' : 'New'} Banner</h3>
      <Form.Item
        label="Label"
        name="description"
        rules={[{ required: true, message: "Required" }]}
      >
        <Input placeholder="Enter banner label" />
      </Form.Item>

      <Form.Item
        label="Publish Date"
        name="start_date"
        rules={[{ required: true, message: "Required" }]}
      >
        <DatePicker
          format="DD/MM/YYYY, HH:mm"
          showTime
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item label="End Date" name="end_date">
        <DatePicker
          format="DD/MM/YYYY, HH:mm"
          showTime
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item label="Navigate To" name="screen">
        <Select placeholder="Screen">
          <Select.Option value="category">Category</Select.Option>
          <Select.Option value="product">Product</Select.Option>
          <Select.Option value="carts">Cart</Select.Option>
          <Select.Option value="webview">External Web URL (To browse on browser)</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="Navigation ID" name="to">
        <Input placeholder="(Optional) Product ID/Category ID/URL" />
      </Form.Item>

      <Form.Item name="file" rules={[{ required: !data, message: "Required" }]}>
        <Upload.Dragger
          maxCount={1}
          accept="image/png, image/jpeg"
          beforeUpload={() => {
            return false;
          }}
        >
          <div className="upload-text-section">
            <p className="ant-upload-text">Drag and drop to upload or</p>
            <div className="ant-upload-hint">Browse</div>
          </div>
        </Upload.Dragger>
      </Form.Item>
      <Button
        loading={loading}
        type="primary"
        htmlType="submit"
        className="btn-primary"
      >
        Submit
      </Button>
    </Form>
  );
}
